import React from 'react';

import ActiveLabel from '../ActiveLabel';

const Success = () => (
  <ActiveLabel text="Password changed" name="passwordChanged" />
);

export default Success;
